import { readStoredUser } from '../services/authApi';

const DIRECT_ADMIN_EMAILS = new Set(['admin@polarace.gg']);

export function readStoredUserEmail() {
  const user = readStoredUser();
  return typeof user?.email === 'string' ? user.email.trim().toLowerCase() : '';
}

export function hasDirectAdminAccess() {
  return DIRECT_ADMIN_EMAILS.has(readStoredUserEmail());
}
